<template>
  <div>
    <v-data-table
      v-model="itensSelecionados"
      :headers="headers"
      :items="items"
      :search="search"
      fixed-header
      height="calc(100vh - 255px)"
      class="table-full-screen"
      show-select
      :items-per-page="-1"
      item-key="index"
    >
      <template v-slot:top>
        <div class="d-flex py-2 pl-3">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-wieght-medium pt-1">
            Tempo de Cobertura por Segmentos
          </p>

          <v-spacer />

          <template v-if="itensSelecionados.length > 0">
            <v-badge color="white" overlap class="mr-6">
              <template v-slot:badge>
                <span style="color: #000">{{itensSelecionados.length}}</span>
              </template>

              <v-btn color="error" @click="confirmarDelecao()">
                <v-icon left>mdi-delete</v-icon>
                Excluir
              </v-btn>
            </v-badge>
          </template>

          <template v-else>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa"
              dense
              single-line
              hide-details
              clearable
              outlined
              v-lazy-input:debounce="500"
              class="pr-4 pl-auto"
              style="max-width: 475px"
            ></v-text-field>

          </template>

          <v-btn class="primary mr-5" @click="dialogCadastroCurvasSegmentos = ! dialogCadastroCurvasSegmentos">
            <v-icon left>mdi-plus</v-icon>
            Configuração Geral
          </v-btn>

          <DialogCurvasSegmentosFilial
            ref="dialog_curvas_segmentos_filial_ref"
            :itemParaEdicao="editedItem"
            @atualizacao="buscarItems()"
            @dialog:fechado="editedItem = {}"
          />

          <dialog-curvas-segmentos
            v-model="dialogCadastroCurvasSegmentos"
            :itemParaEdicao="editedItem"
            @atualizar-lista="buscarItems()"
          ></dialog-curvas-segmentos>
        </div>
      </template>

      <template #item.data-table-select="{item}">
        <v-btn v-if="!itensSelecionados.includes(item)" icon @click="itensSelecionados.push(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-btn v-else icon @click="itensSelecionados = itensSelecionados.filter(sel => sel !== item)">
          <v-icon>mdi-checkbox-marked</v-icon>
        </v-btn>
      </template>

      <template v-slot:header.action="{item}">
        <div style="margin-left: 9px">Ações</div>
      </template>

      <template v-slot:item.idfamilia_produto="{item}">
        <div>
          {{item.idfamilia_produto}} - {{item.descricao_familia_produto}}
        </div>
      </template>

      <template v-slot:item.tempo_cobertura="{item}">
        <span v-if="Number(item.tempo_cobertura)">
          {{ Helpers.formatarValor(item.tempo_cobertura) }} dias
        </span>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </template>

      <template v-slot:item.tempo_cobertura_por_filial="{item}">
        <ListaCoberturas
          :itens="item.tempo_cobertura_por_filial"
          :id_entidade="item.idfamilia_produto"
          entidade="segmento"
          @update:coberturas-filial="buscarItems"
        />
      </template>

      <template v-slot:item.action="{item}">
        <div class="d-flex align-center">
          <EscolhaEdicao
            :item="item"
            @edicao:geral="editarItem"
            @edicao:por-filial="abrirEdicaoPorFilial"
          />

          <v-btn icon @click="itensSelecionados = [item];confirmarDelecao()">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <DialogConfirmacaoTempoCobertura
      v-model="dialogConfirmacaoExclusao"
      color="red"
      @confirmado="deleteItem()"
    >
      <template #body>
        <p v-text="'Deseja realmente excluir itens selecionados?'" />
      </template>
    </DialogConfirmacaoTempoCobertura>
  </div>
</template>

<script>
import DialogCurvasSegmentos from "./DialogCurvasSegmentos.vue"
import DialogCurvasSegmentosFilial from "@/components/Parametrizacao/Cruds/CoberturaPorSegmento/PorFilial/DialogCadastro.vue"
import TempoCoberturaSegmentosAPI from "../../../../api/compras/TempoCoberturaPorSegmentos"
import DialogConfirmacaoTempoCobertura from "./DialogConfirmacaoTempoCobertura.vue"
import {logout} from "@/helpers";
import ListaCoberturas from "@/components/Parametrizacao/Cruds/ListaCoberturas.vue";
import EscolhaEdicao from "@/components/Parametrizacao/Cruds/EscolhaEdicao.vue";

export default {
  name: 'Cobertura',
  components: {
    EscolhaEdicao,
    ListaCoberturas,
    DialogCurvasSegmentos,
    DialogConfirmacaoTempoCobertura,
    DialogCurvasSegmentosFilial,
  },
  data: () => ({
    search: "",
    dialogCadastroCurvasSegmentos: false,
    dialogConfirmacaoExclusao: false,
    headers: [
      { text: '#Id', value: 'id' },
      { text: 'Segmento', value: 'descricao_familia_produto'},
      { text: 'Usuário', value: 'usuario_log' },
      { text: 'Tempo de Cobertura', value: 'tempo_cobertura', width: '180px' },
      { text: 'Tempo de Cobertura Por Filial', value: 'tempo_cobertura_por_filial', width: '250px' },
      { text: 'Ações', value: 'action', width: '130px' }
    ],
    editedItem: {},
    items: [],
    itensSelecionados: [],
  }),
  watch: {
    dialogCadastro (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoAplicar (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoExclusao (dialog) {
      !dialog && (this.itensSelecionados = [])
    }
  },
  created() {
    this.buscarItems()
  },
  methods: {
    confirmarDelecao () {
      this.dialogConfirmacaoExclusao = true
    },
    editarItem (item) {
      this.dialogCadastroCurvasSegmentos = true
      this.editedItem = Object.assign({}, item)
    },
    abrirEdicaoPorFilial (item) {
      this.$refs.dialog_curvas_segmentos_filial_ref.dialog_ativo = true;
      this.editedItem = Object.assign({}, item);
    },
    buscarItems () {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaSegmentosAPI.getListaFull(headers)
          .then((response) => {
            const {token, itens} = response.data;
            localStorage.token = token
            this.items = itens.map((item, index) => ({ ...item, index }));
          })
          .catch(logout)
      );
    },
    deleteItem () {
      const headers = this.Helpers.iniciarRequisicao();

      const segmentos = this.itensSelecionados.map(item => item.idfamilia_produto);

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaSegmentosAPI.deleteMultiplos(headers, { segmentos })
          .then((response) => {
            const {token} = response.data;
            localStorage.token = token
            this.buscarItems()
          })
          .catch(logout)
      );
    },
  }
}
</script>

<style>

</style>
